// TODO - Documentar
import * as con from "../../GlobalConstants"

// Style
import "../ComponentsGlobalStyle.css"
import { TransactionTable } from '../transactionTable/TransactionTable'
import { OptionCoveragesHook, useTransactionAnnotations, useTransactionFilters } from '../hooks/TransactionsHooks'
import TransactionTableVisualizer from './TransactionTableVisualizer'
import { allOptionCoverageColumns, selectedOptionCoverageColumns } from '../../utils/transactionFunctions'
import { useDispatch } from "react-redux"
import { addTransaction, deleteTransaction, updateTransaction } from "../../store/slices/transactionsSlice"

function TableCoveragesOption() {

  // Transaction
  const trans = OptionCoveragesHook()
    
  const dispatch = useDispatch()
  const { filterFun, searchFun } = useTransactionFilters()
  const getAnnotations = useTransactionAnnotations(con.COVERAGES_OPTION)
  
  // Columns
  const columns = selectedOptionCoverageColumns.map(col => allOptionCoverageColumns[col[con.ID]])

  return (
        <TransactionTableVisualizer transactionType={con.COVERAGES_OPTION}>           
                    <TransactionTable transactionType={con.COVERAGES_OPTION}
                                      columnArray={columns} 
                                      dataDictionary={trans} 
                                      setRow={(id, vals) =>
                                        dispatch(updateTransaction({
                                          transactionType: con.COVERAGES_OPTION,
                                          id,
                                          values: vals
                                        }))
                                      }
                                      addRow={(vals) =>
                                        dispatch(addTransaction({
                                          transactionType: con.COVERAGES_OPTION,
                                          values: vals
                                        }))
                                      }
                                      deleteRow={(id) =>
                                        dispatch(deleteTransaction({
                                          transactionType: con.COVERAGES_OPTION,
                                          id
                                        }))
                                      }
                                      getAnnotations={getAnnotations}
                                      filterFunction={filterFun}
                                      searchFunction={searchFun}/>
        </TransactionTableVisualizer>        
  )
}

export default TableCoveragesOption